import { Fulfillment } from 'api';
import { ModelStatus as ModelStatusEnum } from 'dashboard409a/pages/Workboard/common/types';

// Map between ModelStatusEnum (UI) and Fulfillment.model_status (API) values
// Note: The separate is_waiting boolean field on Fulfillment is now used instead of
// model_status=5 (WAITING) to indicate a paused/waiting state. When is_waiting is true,
// all Model Status fields are disabled regardless of the current model_status value.
const modelStatusMap = ({
  [ModelStatusEnum.DRAFT]: 0,
  [ModelStatusEnum.REVIEW]: 1,
  [ModelStatusEnum.IN_PROCESS_SCALAR_USA]: 2,
  [ModelStatusEnum.FINAL]: 3,
  [ModelStatusEnum.REVIEW_FINAL]: 4,
  [ModelStatusEnum.COMPLETE]: 5,
});

// Reverse map for converting API values back to UI values
// Note: model_status=5 is now COMPLETE. The WAITING status is deprecated and handled via
// the is_waiting boolean field. Any existing records with the old model_status=5 (WAITING)
// have been migrated to use is_waiting=True with model_status=0 (DRAFT).
const reverseModelStatusMap = ({
  0: ModelStatusEnum.DRAFT,
  1: ModelStatusEnum.REVIEW,
  2: ModelStatusEnum.IN_PROCESS_SCALAR_USA,
  3: ModelStatusEnum.FINAL,
  4: ModelStatusEnum.REVIEW_FINAL,
  5: ModelStatusEnum.COMPLETE,
});

const userSearchStaleTime = 5 * 60 * 1000;
const userSearchQueryKey = 'staff-users-search';

export type FulfillmentListResponse = {
  results: Array<Fulfillment>,
};


export { modelStatusMap, reverseModelStatusMap, userSearchStaleTime, userSearchQueryKey };